//Generated File 
export const GridColumns = `GridColumns`;
export const GridSeparateColumn = `GridSeparateColumn`;
export const HeaderFields = `HeaderFields`;
export const ListView = `ListView`;
export const SearcherView = `SearcherView`;
export const Suggestion = `Suggestion`;
